import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription, debounceTime } from 'rxjs';
import { IFlowViewModel } from '../../../../core/visual/work-flow-editor/models/i-flow-view-model';
import { EventsFlowActionNodeTypes } from '../../models/events-flow-action-node-types';
import { INodeStaticMapItem } from '../i-node-static-map-item';
import { EventsFlowEventNodeTypes } from '../../models/events-flow-event-node-types';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor } from '@angular/common';
import { MatTextInputComponent } from '../../../../editors/mat-text-input/mat-text-input.component';
import { FExternalItemDirective } from '@foblex/flow';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-workflow-palette-actions',
    templateUrl: './workflow-palette-actions.component.html',
    styleUrls: ['./workflow-palette-actions.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatTextInputComponent,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        FExternalItemDirective,
        MatTooltip,
        MatIcon,
    ],
})
export class WorkflowPaletteActionsComponent {
  @Input({ required: true })
  nodeType: string;

  @Output()
  public readonly actionClicked = new EventEmitter<INodeStaticMapItem>();

  public filteredActions: INodeStaticMapItem[] = [];

  public readonly searchControl = new FormControl();
  public actions: INodeStaticMapItem[] = [];

  private readonly _subscriptions = new Subscription();

  constructor(private readonly _cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.setAvailableActions();

    this.filteredActions = [...this.actions];

    this._subscriptions.add(this.subscribeSearch());
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private subscribeSearch(): Subscription {
    return this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((data: string) => {
      this.filteredActions = this.actions.filter(event => event.name.toLowerCase().includes(data?.toLowerCase() || ''));
      this._cdr.detectChanges();
    });
  }

  private setAvailableActions() {
    this.actions = [
      {
        name: 'Send to URL',
        icon: 'http',
        color: 'primary',
        isExpandable: true,
        hasInput: true,
        hasOutput: true,
        type: EventsFlowActionNodeTypes.SendToUrl,
        description: 'Send the event to a URL',
      },

      {
        name: 'AI-Powered Recording Transcription',
        icon: 'memory',
        color: 'primary',
        isExpandable: true,
        hasInput: true,
        hasOutput: true,
        type: EventsFlowActionNodeTypes.TranscribeCallRecording,
        description: 'Get recording transcription with additional insights',
        visibleOnlyFor: [EventsFlowEventNodeTypes.OnRecordingAvailable],
      },

      {
        name: 'Record Patient Note',
        icon: 'note',
        color: 'accent',
        isExpandable: true,
        hasInput: true,
        hasOutput: true,
        type: EventsFlowActionNodeTypes.SendPatientNote,
        description: 'Record a note for the patient',
      },

      {
        name: 'Record Caregiver Note',
        icon: 'note',
        color: 'accent',
        isExpandable: true,
        hasInput: true,
        hasOutput: true,
        type: EventsFlowActionNodeTypes.SendCaregiverNote,
        description: 'Record a note for the caregiver',
      },
    ].filter(item => !item.visibleOnlyFor || item.visibleOnlyFor.includes(this.nodeType as any));
  }
}
